import { render, staticRenderFns } from "./layout-options.vue?vue&type=template&id=4fe15c75&scoped=true"
import script from "./layout-options.vue?vue&type=script&lang=js"
export * from "./layout-options.vue?vue&type=script&lang=js"
import style0 from "./layout-options.vue?vue&type=style&index=0&id=4fe15c75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe15c75",
  null
  
)

export default component.exports